<mat-icon [svgIcon]="customIcon && icon">
  {{ icon }}
</mat-icon>
